import { DataAccess } from "../dataaccess/data.access";

export interface DocusignConnection {
    connected: boolean;
    hmacConfigured: boolean;
    enabled: boolean;
    integrationId?: number;
    accountName?: string;
    senderName?: string;
    consentUrl?: string;
}

export interface DocusignRecipientRow {
    recipientId: string;
    name: string;
    email: string;
    status: string;
    completedDt?: string | null;
}

export interface DocusignEnvelopeList {
    envelopes?: DocusignEnvelopeRow[];
    message?: string;
}

export interface DocusignEnvelopeRow {
    docusignEnvelopeId: string;
    documentId?: number;
    status: string;
    signingMode: string;
    sentByUsername: string;
    sentDt?: string | null;
    completedDt?: string | null;
    fileKey?: string;
    sentFileName?: string | null;
    signedFileName?: string | null;
    recipients?: DocusignRecipientRow[];
}

export interface DocusignSigner {
    name: string;
    email: string;
}

export interface DocusignSendBody {
    documentId: number;
    documentRunId: number;
    reportId: number;
    reportRunId: number;
    objectTypeId: number;
    objectId: number;
    documentName?: string;
    recipients?: DocusignSigner[];
}

export class DocusignApi {
    static connection() {
        return DataAccess.get<DocusignConnection>("/document/docusign/connection.json");
    }

    static connect() {
        return DataAccess.get<DocusignConnection>("/document/docusign/connect.json");
    }

    static saveSettings(senderName: string, hmacSecret: string) {
        return DataAccess.put<DocusignConnection>("/document/docusign/settings.json", {
            docusign_settings: { senderName, hmacSecret },
        });
    }

    static envelopes(objectTypeId: number, objectId: number, documentId: number) {
        return DataAccess.get<DocusignEnvelopeList>(
            `/document/docusign/envelopes.json?objectTypeId=${objectTypeId}&objectId=${objectId}&documentId=${documentId}`,
        );
    }

    static send(body: DocusignSendBody) {
        return DataAccess.post<DocusignEnvelopeRow>("/document/docusign/send.json", { docusign_send: body });
    }

    static voidEnvelope(docusignEnvelopeId: string) {
        return DataAccess.post<DocusignEnvelopeRow>(`/document/docusign/${docusignEnvelopeId}/void.json`, {});
    }
}
